import { useEffect, useRef, useState } from "react";
import { activeAuthorsByKeywords } from "../../../api/specialization/AuthorSpecializationAPI";
import { OptionsObject, useSnackbar } from "notistack";
import { AlertErrorProp } from "../../../components/SnackbarNoti";
import { Bar, getElementsAtEvent } from "react-chartjs-2";
import { horizontalChartOptions } from "../../../util/ChartStyleUtil";
import { labels, datas } from "./AuthorStatsConverter";
import { findContentFlexFilter } from "../../../api/content/ContentAPI";
import ContentListPopup from "../../../components/popup/ContentListPopup";
import { Chart } from "chart.js";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
import AuthorCountComponent from "./AuthorCountComponent";
import { List } from "@mui/material";

type KeywordProps = {
  keyword: string;
  days: number;
};

export function AuthorKeywordChart(props: KeywordProps) {
  var keyword = props.keyword;
  var days = props.days;
  const [authorStats, setAuthorStats] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [popup, setPopup] = useState(false);
  const [sources, setSources] = useState([]);
  const [chosenAuthor, setChosenAuthor] = useState({ author: "", source: "" });
  const { t } = useTranslation(["common"]);
  const onClosePopup = () => {
    setPopup(false);
    setSources([]);
  };
  useEffect(() => {
    activeAuthorsByKeywords(keyword, days)
      .then((res) => {
        setAuthorStats(res);
      })
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [keyword, days]);
  useEffect(() => {
    if (chosenAuthor["author"].length > 0) {
      findContentFlexFilter({
        keyword: props.keyword,
        days: props.days + 1,
        author: chosenAuthor["author"],
        source: chosenAuthor["source"],
      })
        .then((res) => setSources(res))
        .catch((err) => {
          var noti = errorNoti(err);
          enqueueSnackbar(t("error:" + noti.message), noti.option);
        });
    }
  }, [chosenAuthor]);

  var maxCount = authorStats.length > 0 ? authorStats[0]["points"] : 1;
  var elements = authorStats.slice(0, 5).map((stat) => {
    return (
      <div
        onClick={() => {
          setChosenAuthor(stat);
          setPopup(true);
        }}
      >
        <AuthorCountComponent
          name={stat["author"]}
          source={stat["source"]}
          count={stat["points"]}
          scaledNumber={stat["points"] / maxCount}
        />
      </div>
    );
  });
  return (
    <div>
      <List>{elements}</List>
      <ContentListPopup
        popup={popup}
        onClosePopup={onClosePopup}
        contents={sources}
        title={
          "Các bài báo gần đây về " +
          props.keyword +
          " bởi " +
          chosenAuthor["author"] +
          " - " +
          chosenAuthor["source"]
        }
      />
    </div>
  );
}
